import React from 'react'
import './LeftBar.scss';
import { useSelector, useDispatch } from 'react-redux'
import {
    leftBarClicked,
    searchBarClicked,
    filterBarClicked,
} from '../redux/actions/index'
import { ReactComponent as BackspaceIcon } from '../assets/svg/leftBar/backspace.svg'
import { ReactComponent as FilterIcon } from '../assets/svg/leftBar/filter.svg'
import { ReactComponent as PlusIcon } from '../assets/svg/leftBar/plus.svg'
import { ReactComponent as RefreshIcon } from '../assets/svg/leftBar/refresh.svg'
import { ReactComponent as SearchIcon } from '../assets/svg/leftBar/search.svg'
import { ReactComponent as TrashbinIcon } from '../assets/svg/leftBar/trashbin.svg'
import { ReactComponent as RightwardIcon } from '../assets/svg/leftBar/rightward.svg'
import SearchInputBox from '../components/SearchInputBox';

// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import dayjs from 'dayjs';


function LeftBar({ resultCount, displayLimit, searchValue, setSearchValue, constData, setProgrammiDispData, setLoading, setFilterLoading, singleSearch,
    exitRequestController, multiSearch, filterLoading, filterData, setFilterData, setDisplayLimit }) {
    const dispatch = useDispatch()
    const topTapData = useSelector((state) => state.topTab)
    const leftTab = useSelector((state) => state.leftTab)

    const leftBarClickeD = () => { dispatch(leftBarClicked()) }
    const searchBarClickeD = () => { dispatch(searchBarClicked()) }
    const filterBarClickeD = () => { dispatch(filterBarClicked()) }

    return (
        <div className="LeftBar">
            <div className="title-top">
                <p className="topTitle">
                    {topTapData?.items[topTapData.nowId - 1]?.name}
                </p>
                <div className="right-icons">
                    <PlusIcon />
                    <RefreshIcon />
                    <RightwardIcon className="rotate-anti-clockwise" />
                </div>
            </div>
            <div className="title-second">
                <p className="topTitle">Numero risultati</p>
                <div className="right-icons">
                    <p>{Math.min(resultCount, displayLimit)}/{resultCount}</p>
                    <RightwardIcon
                        className={
                            leftTab?.flag ? 'rotate-anti-clockwise' : 'rotate-clockwise'
                        }
                        onClick={leftBarClickeD}
                    />
                </div>
            </div>
            <div className={leftTab.flag ? '' : 'hidden'}>
                <div className="side-panel">
                    <div className="inter-line"></div>
                    <div className="title">
                        <div className="left">
                            <SearchIcon />
                            <p>Ricerca</p>
                        </div>
                        <div className="right">
                            <BackspaceIcon onClick={() => {
                                setSearchValue([...constData?.defaultSearchValue])
                                setProgrammiDispData([])
                                setLoading(false)
                                setFilterLoading(false)
                            }} />
                            <RightwardIcon className={leftTab?.searchTab?.flag ? 'rotate-anti-clockwise' : 'rotate-clockwise'}
                                onClick={searchBarClickeD}
                            />
                        </div>
                    </div>
                    <div className={leftTab?.searchTab?.flag ? '' : 'hidden'}>
                        <div className={leftTab?.filterTab?.flag ? "search-items scroll" : "search-items scroll long"}>
                            {constData?.defaultSearchValue?.map((item, index) => {
                                return (
                                    <div className="item" key={'searchPanelItem' + index}>
                                        <p>{item.name}</p>
                                        {(() => {
                                            const enabledSearchInputBox = <SearchInputBox index={index} searchValue={searchValue} setSearchValue={setSearchValue}
                                                singleSearch={singleSearch} setLoading={setLoading} setFilterLoading={setFilterLoading} enable={true} />
                                            const diabledSearchInputBox = <SearchInputBox index={index} searchValue={searchValue} setSearchValue={setSearchValue}
                                                singleSearch={singleSearch} setLoading={setLoading} setFilterLoading={setFilterLoading} enable={false} />
                                            const increasingInputBox = <div>
                                                {(() => {
                                                    if (item.name !== 'ID Produzione' && item.name !== 'Codice Produzione') return
                                                    return searchValue[index]?.value?.map((iitem, iindex) => {
                                                        let tempSearchValue = searchValue
                                                        return (
                                                            <div className='search-box' key={'search-box-array-' + iindex}>
                                                                <input type="text" name={index} value={iitem || ''}
                                                                    onChange={(e) => {
                                                                        tempSearchValue[index].value[iindex] = e.target.value || null
                                                                        tempSearchValue[index]?.value.forEach((iiitem, iiindex) => {
                                                                            if (!iiitem && iiindex !== tempSearchValue[index].value?.length - 1) {
                                                                                tempSearchValue[index]?.value.splice(iiindex, 1)
                                                                            }
                                                                        })
                                                                        if (iindex === searchValue[index]?.value?.length - 1) {
                                                                            tempSearchValue[index].value.push(null)
                                                                        }
                                                                        setSearchValue([...tempSearchValue])
                                                                    }}
                                                                    onKeyPress={(e) =>
                                                                        e.key === 'Enter' && singleSearch(index)
                                                                    } />
                                                                <div className="right">
                                                                    <SearchIcon onClick={() => { singleSearch(index) }} />
                                                                    <TrashbinIcon
                                                                        onClick={() => {
                                                                            if (!tempSearchValue[index].value[iindex]) return
                                                                            tempSearchValue[index].value.splice(iindex, 1)
                                                                            setSearchValue([...tempSearchValue])
                                                                            setLoading(false)
                                                                            setFilterLoading(false)
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                })()}
                                            </div>
                                            const searchCheckBox = <input type="checkbox" checked={searchValue[index]?.value} onChange={(e) => {
                                                let tempSearchValue = searchValue
                                                tempSearchValue[index].value = !tempSearchValue[index]?.value
                                                setSearchValue([...tempSearchValue])
                                            }} />
                                            const timePicker = <div className='search-input-box'>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    {/* <DateTimePicker value={value} onChange={(newValue) => setValue(newValue)}/> */}
                                                    <MobileDateTimePicker openTo="year" format="YYYY-MM-DD HH:mm"
                                                    value={dayjs(searchValue[index]?.value).isValid()? dayjs(searchValue[index]?.value) : null} 
                                                    onChange={(newValue) => {
                                                        let tempSearchValue = searchValue
                                                        tempSearchValue[index].value = dayjs(newValue).format('YYYY-MM-DD HH:mm')
                                                        setSearchValue([...tempSearchValue])
                                                        // console.log(tempSearchValue[index].value)
                                                    }}/>
                                                </LocalizationProvider>
                                                <div className="right">
                                                    <SearchIcon onClick={() => { singleSearch(index) }} />
                                                    <TrashbinIcon
                                                        onClick={() => {
                                                            let tempSearchValue = [...searchValue]
                                                            tempSearchValue[index].value = null
                                                            setSearchValue(tempSearchValue)
                                                            setLoading(false)
                                                            setFilterLoading(false)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            switch (item.name) {
                                                case 'Utilizzatore': return enabledSearchInputBox
                                                case 'Canale': return enabledSearchInputBox
                                                case 'Produzione': return enabledSearchInputBox
                                                case 'ID Produzione': return increasingInputBox
                                                case 'Codice Produzione': return increasingInputBox
                                                case 'Genere Produzione': return enabledSearchInputBox
                                                case 'Master': return diabledSearchInputBox
                                                case 'ID Master': return diabledSearchInputBox
                                                case 'Codice Master': return diabledSearchInputBox
                                                case 'Escludi Cloni': return searchCheckBox
                                                case 'Escludi Film': return searchCheckBox
                                                case 'Solo Film': return searchCheckBox
                                                case 'Stato Master': return diabledSearchInputBox
                                                case 'Da data': return timePicker
                                                case 'A data': return timePicker
                                                default: return <></>
                                            }
                                        })()}
                                    </div>
                                )
                            })}
                        </div>
                        <div className="buttons">
                            <div
                                className="left"
                                onClick={() => {
                                    exitRequestController.abort()
                                    console.log("abort.............")                              //________________________________________________________________WORKing?
                                    setSearchValue([...constData.defaultSearchValue])
                                    setProgrammiDispData([])
                                    setLoading(false)
                                    setFilterLoading(false)
                                }}
                            >
                                <p>PULISCI</p>
                            </div>
                            <div className="right" onClick={() => multiSearch()}>
                                <p>CERCA</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="side-panel">
                    <div className="inter-line"></div>
                    <div className="title">
                        <div className="left">
                            <FilterIcon />
                            <p>Filtri</p>
                            <div className={filterLoading ? 'filter-loading' : ''}></div>
                        </div>
                        <div className="right">
                            <BackspaceIcon onClick={() => {
                                let tempFilterData = filterData
                                tempFilterData.forEach((item) => {
                                    item.data.forEach((iitem) => {
                                        iitem.checked = false
                                    })
                                })
                                setFilterData([...tempFilterData])
                            }} />
                            <RightwardIcon
                                className={leftTab?.filterTab?.flag ? 'rotate-anti-clockwise' : 'rotate-clockwise'}
                                onClick={filterBarClickeD}
                            />
                        </div>
                    </div>
                    <div className={leftTab?.filterTab?.flag ? (leftTab?.searchTab?.flag ? 'filter-items scroll' : 'filter-items scroll long') : 'hidden'}>
                        {filterData?.map((item, index) => {
                            if (item?.data.length)
                                return (
                                    <div className="item" key={'filterPanelItem' + index}>
                                        <p onClick={() => {
                                            let tempFilterData = filterData
                                            item.data.find(iitem => iitem.checked === false) ?
                                                tempFilterData[index].data.forEach((iiitem) => { iiitem.checked = true })
                                                : tempFilterData[index].data.forEach((iiitem) => { iiitem.checked = false })
                                            setFilterData([...tempFilterData])
                                        }}><u>{item?.title}</u></p>
                                        {item?.data?.map((iitem, iindex) => {
                                            if (iindex < item.limitCount)
                                                return (
                                                    <div className="check-box" key={'filterPanelItem' + index + '-' + iindex}>
                                                        <div className='left'>
                                                            <input type="checkbox" defaultChecked={filterData[index].data[iindex].checked} onChange={() => {
                                                                let tempFilterData = filterData
                                                                tempFilterData[index].data[iindex].checked = !tempFilterData[index].data[iindex].checked
                                                                setFilterData([...tempFilterData])                    //---------------------------------------------------------Add sort filter by flag
                                                                setDisplayLimit(constData.countPerPage)
                                                            }} checked={filterData[index].data[iindex].checked} />
                                                            <p>{iitem?.name}</p>
                                                        </div>
                                                        <p>({iitem?.count})</p>
                                                    </div>
                                                )
                                            else return <></>
                                        })}
                                        <div className={item.data.length > item.limitCount ? 'show-more' : 'hidden'} onClick={() => {
                                            let tempFilterData = filterData
                                            tempFilterData[index].limitCount += constData.countPerFilter
                                            setFilterData([...tempFilterData])
                                        }}>Show More...</div>
                                    </div>
                                )
                            else return <></>
                        })}
                        <div className="space"></div>
                    </div>
                </div>
                <div className="space"></div>
            </div>
        </div>
    )
}

export default LeftBar